import { PureComponent } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { ProviderSet } from "@app/provider-sets/providerSet";
import { ProviderSetType } from "@app/provider-sets/enumerations";
import { Link } from "react-router-dom";
import { FlyoutContextOutgoingProps, FlyoutFooter, withFlyoutContext } from "@app/shared/Flyouts";
import ProjectInfoSummary from "@app/projects/projectInfoSummary";
import ProjectService from "@app/projects/projectService";
import { QESButton } from "@app/shared/qes-standards/Button";

interface ArchivePanelProps {
  providerSet: ProviderSet
  loading: boolean;
  handleArchive: () => void;
}

interface ArchivePanelState {
  associatedProjects: ProjectInfoSummary[];
  filteredProviders: ProviderSet[];
  loading: boolean;
}

class WrappedArchivePanelContent extends PureComponent<ArchivePanelProps & FlyoutContextOutgoingProps, ArchivePanelState> {
  constructor(props: ArchivePanelProps & FlyoutContextOutgoingProps) {
    super(props);
    this.state = {
      associatedProjects: [],
      filteredProviders: [],
      loading: (true)
    };
  }

  private projectService = new ProjectService();

  public async componentDidMount() {
    if (!this.props.providerSet)
      return;

    let assocProjects: ProjectInfoSummary[] = [];
    if (this.props.providerSet.providerSetType === ProviderSetType.Standard || this.props.providerSet.providerSetType === ProviderSetType.AccessReporting) {
      assocProjects = await this.projectService.getProjectSummaryByProviderSetIdAsync(this.props.providerSet.resource.resourceId);
    } else {
      assocProjects = await this.projectService.getV1ProjectByProviderSetIdAsync(this.props.providerSet.resource.resourceId, this.props.providerSet.providerSetType);
    }

    this.setState({
      associatedProjects: assocProjects,
      filteredProviders: (!!this.props.providerSet.filteredProviderSets ? this.props.providerSet.filteredProviderSets.filter(x => !x.resource.datePurged && !x.resource.dateArchived) : []),
      loading: (false)
    });
  }

  public render() {
    return (
      <>
        {this.props.loading || this.state.loading ? <LoadingSpinner /> :
          <>
            <p className="fs20" >
              <strong>Archive Provider Network</strong>
            </p>
            {this.state.associatedProjects.length > 0 || this.state.filteredProviders.length > 0 ?
              <p className="mt-2 fs16"><i className="fa fa-exclamation-triangle text-danger me-1"></i>This provider network cannot be archived because it is referenced by the following active Filtered Networks and/or Projects.</p>
              : null
            }
            {this.state.filteredProviders.length > 0 ?
              <>
                <p className="fs18 mb-1">
                  Associated Filtered Networks:
                </p>
                <ul className="list-unstyled ms-4">
                  {this.state.filteredProviders.map(x =>
                    <li key={x.resource.resourceId}>
                      <i className="fa fa-chain me-2"></i><Link to={{ pathname: `/provider-sets/${x.resource.resourceId}/detail` }} >{x.resource.name}</Link>
                    </li>)}
                </ul>
              </> : null
            }
            {this.state.associatedProjects.length > 0 ?
              <>
                <p className="fs18 mb-1">
                  Associated Projects:
                </p>
                <ul className="list-unstyled ms-4">
                  {this.state.associatedProjects.map(x =>
                    <li key={x.projectId}>
                      <i className="fa fa-chain me-2"></i>
                      {this.props.providerSet.providerSetType === ProviderSetType.Standard ?
                        <Link to={{ pathname: `/projects/${x.projectId}` }} >{x.name}</Link> :
                        <a href={`${window.uiEndpoint}/${this.props.providerSet.providerSetType}/projects/${x.projectId}`} >{x.name}</a>
                      }
                    </li>)}
                </ul>
              </> : null
            }
            {this.state.associatedProjects.length === 0 && this.state.filteredProviders.length === 0 ?
              <p className="fs18">
                <i className="fa fa-check mr10 text-success"></i>Are you sure you want to archive this provider network?
              </p>
              : null
            }
            <FlyoutFooter
              submitButton={
                <QESButton
                  qesTestId="archive-provider-set-panel-content__confirm"
                  className="me-2"
                  qesType="primary-danger"
                  disabled={this.state.associatedProjects.length > 0 || this.state.filteredProviders.length > 0}
                  onClick={() => { this.props.handleArchive(); this.props.handleCloseFlyout(); }}
                >Archive</QESButton>
              }
            />
          </>
        }
      </>
    );
  }
}

const ArchivePanelContent = withFlyoutContext(WrappedArchivePanelContent);
export default ArchivePanelContent;